import Immutable from 'immutable';
import {handleActions} from 'redux-actions';

const defaultState = Immutable.fromJS({
  errors: {},
  errorStatus: 0
})

export default handleActions({
  GLOBAL_FAILURE: {
    next(state, action) {
      // nothing to do at this version
      return state.merge({errors: action.payload})
    },
    throw(state, action) {
      return state.merge({errors: action.payload})
    },
  },
  ERROR_STATUS: (state, action) => {
    return state.merge({errorStatus: action.payload})
  }
}, defaultState)
